import React, { useState, useEffect } from "react";
import { Image, Button, Icon, Modal, Table } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { ENV } from "../../../../utils";
import { Permission, Socialform } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SocialForm } from "../SocialForm";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import "./SocialFormItem.scss";
import {
  formatDateHourCompleted,
  formatDateView,
} from "../../../../utils/formatDate";
import { useLanguage } from "../../../../contexts";

const socialFormController = new Socialform();
const permissionController = new Permission();

export function SocialFormItem(props) {
  const { socialForm, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  const openUpdateSocial = () => {
    setTitleModal(`t("update") Formulario de Sitio`);
    onOpenCloseModal();
  };

  const onDelete = async () => {
    try {
      await socialFormController.deleteSocialForm(accessToken, socialForm._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Table.Row key={socialForm._id}>
        <Table.Cell>
          <Icon color={socialForm.active ? "green" : "red"} name="circle" />
        </Table.Cell>
        <Table.Cell>{formatDateView(socialForm.date)}</Table.Cell>
        <Table.Cell>
          {socialForm.creator_user
            ? socialForm.creator_user.lastname
              ? socialForm.creator_user.lastname +
                " " +
                socialForm.creator_user.firstname
              : socialForm.creator_user.email
            : null}
        </Table.Cell>
        <Table.Cell>
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionsByRole, role._id, "permissions", "edit") ? (
            <Button icon primary onClick={openUpdateSocial}>
              <Icon name="pencil" />
            </Button>
          ) : null}
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(
            permissionsByRole,
            role._id,
            "permissions",
            "delete"
          ) ? (
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="trash" />
            </Button>
          ) : null}
        </Table.Cell>
      </Table.Row>
      {/* <Button icon as="a" href={socialForm.url} target="_blank">
            <Icon name="eye" />
          </Button>
          <Button icon primary onClick={openUpdateSocial}>
            <Icon name="pencil" />
          </Button>
          <Button icon color="red" onClick={onOpenCloseConfirm}>
            <Icon name="trash" />
          </Button> */}

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={titleModal}
        size={"fullscreen"}
      >
        <SocialForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          socialForm={socialForm}
        />
      </BasicModal>

      <Modal open={showConfirm} onClose={onOpenCloseConfirm} size="tiny">
        <Modal.Header>{t("delete")}</Modal.Header>
        <Modal.Content>
          {`${t("delete_social_form_with_date")} ${formatDateView(socialForm.date)}`}
        </Modal.Content>
        <div style={{ display: "flex", justifyContent: "center", gap: "1rem", padding: "1rem" }}>
          <Button color="red" onClick={onDelete}>{t("accept")}</Button>
          <Button secondary onClick={onOpenCloseConfirm}>{t("cancel")}</Button>
        </div>
      </Modal>
    </>
  );
}
